/* tslint:disable */

export class DecisionServiceVersionPairData {
		PairId: number;
		ValueForTrue: string;
		ValueForFalse: string;

}



// WEBPACK FOOTER //
// D:/a/1/s/src/services/generated/models/DecisionServiceVersionPairData.ts